// Created/Updated by Developer - 05/01/2024

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action,ApiResponseModel,CtButtonComponent,CtCardComponent,CtColumnComponent,CtHeaderComponent,CtInputTextComponent,CtMessageContainerComponent,CtRowComponent,CtViewComponent,EntityField, HttpService, UtilService } from 'components';
import { Router } from '@angular/router';
import { defaultIfEmpty, take } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';

@Component({
	selector: 'av-vi11',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi11 extends BaseController {

	public numObjeto: number;
	public titleObjeto: string;
	public descriptionObjeto: string;

	//Util
	private subcriptions : Subscription[] = [];

	constructor(private router : Router) {
		super();
		super.setViewCode('AV_VI11');
	}

	ngOnDestroy(): void {
		this.storeService.deleteState('NUM_OBJETO');
		this.storeService.deleteState('NOMBRE_OBJETO');
	}


	/* ---------------------- CONTROLLER LOGIC ------------------- */

	  public setValuesObjeto(): void {		
		const titleNombreObjeto: CtViewComponent = this.utilService.currentView.getRoot();
		const messageContainer: CtMessageContainerComponent = this.utilService.getComponentRef('CtMessageContainer_347e63ec')
		

		const numObjeto$ = this.storeService.getStateObservable('NUM_OBJETO').pipe(
			take(1),
			defaultIfEmpty('')
		);
	
		const titleDescription$ = this.storeService.getStateObservable('NOMBRE_OBJETO').pipe(
			take(1),
			defaultIfEmpty('')
		);
		this.subcriptions.push(combineLatest([numObjeto$, titleDescription$]).subscribe({
			next: ([numObjeto, titleDescription]: any) => {
				if (numObjeto === '') this.router.navigate(['home/view/AV_VI05']);
				else {
					this.numObjeto = numObjeto;
				}
				if (titleDescription === '') this.router.navigate(['home/view/AV_VI05']);
				else {
					this.titleObjeto = titleDescription;
				}
			}
		}));
		if(this.titleObjeto ==='Póliza de vida'){
			this.descriptionObjeto = 'Encuentre información de su póliza de vida.';
		}else{
			this.descriptionObjeto = 'Encuentre información de su crédito.'
		}
		titleNombreObjeto.setTitle(this.titleObjeto);
		titleNombreObjeto.setDescription(this.descriptionObjeto);
		
		
		this.setADN(this.numObjeto,this.titleObjeto);
		this.setMessage(this.numObjeto,messageContainer);
	}

		public loadDetalleSummary(adn: any, type: number){
			//inputs compartidos
			let periodoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_f738a5aa');
			let fechaPagoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2a25c01b');
			let estadoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2a25c01p');
			let cardIban: CtCardComponent = this.utilService.getComponentRef('crdCtCard_940d6382')
			//inputs de mutual
			let montoAseguradoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_f7monto');
			let cuotaMensualMutualInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_f7mensual');
			let cuotasCubiertasMutualInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_f7cubiertas');
			let cuotasDeudaMutualInput : CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2adeuda');
			let beneficiariosInput : CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2abene');
			//inputs de cred
			let montoOtorgadoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_f7otorgado');
			let tasaInteresInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2aInteres');
			let tipoTasaInteresInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2a25c01C');
			let plazoCreditoInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_5ed0539d');
			let cuotasCubiertasCredInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2acubiertasCred');
			let cuotaMensualCredInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2aMensualCred');
			let saldoCancelarInput: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_2da7cbc6');
			//componente que contienen la seccion de button informacion de interes
			let ctHeaderMutuButton: CtHeaderComponent = this.utilService.getComponentRef('hdrFrmCtForm_899e2fbdMutu');
			let ctBtnMutu: CtButtonComponent= this.utilService.getComponentRef('btnCtButton_51ccdBtnMutu041');
			
			//1 = poliza y 2 = cred
			if(type === 1){
				const dataMutual = this.getDataFromAdnMutual(adn['Data']);
				this.setMutuMessagesUnhidden(ctHeaderMutuButton, ctBtnMutu);
				periodoInput.setValue(dataMutual.periodoInput);
				fechaPagoInput.setValue(dataMutual.fechaPagoInput);
				estadoInput.setValue(dataMutual.estadoInput);
				montoAseguradoInput.setValue(dataMutual.montoAseguradoInput);
				cuotaMensualMutualInput.setValue(dataMutual.cuotaMensualMutualInput);
				cuotasCubiertasMutualInput.setValue(dataMutual.cuotasCubiertasMutualInput);
				cuotasDeudaMutualInput.setValue(dataMutual.cuotasDeudaMutualInput);
				beneficiariosInput.setValue(dataMutual.beneficiariosInput);
				this.setStyleForEstadoObjeto(dataMutual.cuotasDeudaMutualInput,dataMutual.estadoInput);
				this.unhiddenMutual(montoAseguradoInput, cuotaMensualMutualInput, cuotasCubiertasMutualInput,cuotasDeudaMutualInput,beneficiariosInput);
				cardIban.setDescription('Puede realizar el pago de su prima de la póliza depositando el dinero en la siguiente cuenta IBAN.');
				this.setCuentaIban(dataMutual.cuentaIban,cardIban);
			}else{
				const dataCredito = this.getDataFromAdnCredito(adn['Data']);
				periodoInput.setValue(dataCredito.periodoInput);
				fechaPagoInput.setValue(dataCredito.fechaPagoInput);
				estadoInput.setValue(dataCredito.estadoInput);
				montoOtorgadoInput.setValue(dataCredito.montoOtorgadoInput);
				tasaInteresInput.setValue(dataCredito.tasaInteresInput);
				tipoTasaInteresInput.setValue(dataCredito.tipoTasaInteresInput);
				plazoCreditoInput.setValue(dataCredito.plazoCreditoInput);
				cuotasCubiertasCredInput.setValue(dataCredito.cuotasCubiertasCredInput);
				cuotaMensualCredInput.setValue(dataCredito.cuotaMensualCredInput);
				saldoCancelarInput.setValue(dataCredito.saldoCancelarInput);
				this.setStyleForEstadoObjeto('0',dataCredito.estadoInput);
				this.unhiddenCredito(montoOtorgadoInput, tasaInteresInput, tipoTasaInteresInput,plazoCreditoInput,cuotasCubiertasCredInput,cuotaMensualCredInput,saldoCancelarInput);
				cardIban.setDescription('Puede realizar el pago de su cuota del crédito depositando el dinero en la siguiente cuenta IBAN.');
				this.setCuentaIban(dataCredito.cuentaIban,cardIban);
			}
		
		}

		private getDataFromAdnCredito(adn: any): { periodoInput: string, fechaPagoInput: string, estadoInput: string, montoOtorgadoInput: string, tasaInteresInput: string, tipoTasaInteresInput: string, plazoCreditoInput: string, cuotasCubiertasCredInput : string, cuotaMensualCredInput : string, saldoCancelarInput: string, cuentaIban : string } {
			return {
			  periodoInput : this.utilService.getStringAttribute('PERIODO', adn[0].ArrayEntities.List),
			  fechaPagoInput: this.utilService.getStringAttribute('FECHA_PAGO', adn[0].ArrayEntities.List),
			  estadoInput: this.utilService.getStringAttribute('ESTADO', adn[0].ArrayEntities.List),
			  montoOtorgadoInput: this.utilService.getStringAttribute('MONTO_OTORGADO', adn[0].ArrayEntities.List),
			  tasaInteresInput: this.utilService.getStringAttribute('TASA_INTERES', adn[0].ArrayEntities.List),
			  tipoTasaInteresInput: this.utilService.getStringAttribute('TIPO_TASA', adn[0].ArrayEntities.List),
			  plazoCreditoInput: this.utilService.getStringAttribute('PLAZO_CREDITO', adn[0].ArrayEntities.List),
			  cuotasCubiertasCredInput: this.utilService.getStringAttribute('CUOTAS_CUBIERTAS', adn[0].ArrayEntities.List),
			  cuotaMensualCredInput: this.utilService.getStringAttribute('CUOTA_MENSUAL', adn[0].ArrayEntities.List),
			  saldoCancelarInput: this.utilService.getStringAttribute('SALDO_CANCELAR', adn[0].ArrayEntities.List),
			  cuentaIban : this.utilService.getStringAttribute('CUENTA_IBAN', adn[0].ArrayEntities.List)
			};
		  }

		private getDataFromAdnMutual(adn: any): { periodoInput: string, fechaPagoInput: string, estadoInput: string, montoAseguradoInput: string, cuotaMensualMutualInput: string, cuotasCubiertasMutualInput: string, cuotasDeudaMutualInput: string, beneficiariosInput : string, cuentaIban : string } {
			return {
			  periodoInput : this.utilService.getStringAttribute('PERIODO', adn[0].ArrayEntities.List),
			  fechaPagoInput: this.utilService.getStringAttribute('FECHA_PAGO', adn[0].ArrayEntities.List),
			  estadoInput: this.utilService.getStringAttribute('ESTADO', adn[0].ArrayEntities.List),
			  montoAseguradoInput: this.utilService.getStringAttribute('MONTO_ASEGURADO', adn[0].ArrayEntities.List),
			  cuotaMensualMutualInput: this.utilService.getStringAttribute('CUOTA_MENSUAL', adn[0].ArrayEntities.List),
			  cuotasCubiertasMutualInput: this.utilService.getStringAttribute('CUOTA_PAGAS', adn[0].ArrayEntities.List),
			  cuotasDeudaMutualInput: this.utilService.getStringAttribute('CUOTAS_DEUDA', adn[0].ArrayEntities.List),
			  beneficiariosInput: this.utilService.getStringAttribute('BENEFICIARIOS', adn[0].ArrayEntities.List),
			  cuentaIban: this.utilService.getStringAttribute('CUENTA_IBAN', adn[0].ArrayEntities.List)
			};
		  }

		private unhiddenMutual(montoAseguradoInput: CtInputTextComponent,cuotaMensualMutualInput: CtInputTextComponent,cuotasCubiertasMutualInput: CtInputTextComponent,cuotasDeudaMutualInput: CtInputTextComponent,beneficiariosInput: CtInputTextComponent) {
			montoAseguradoInput.setHidden(false);
			cuotaMensualMutualInput.setHidden(false);
			cuotasCubiertasMutualInput.setHidden(false);
			cuotasDeudaMutualInput.setHidden(false);
			beneficiariosInput.setHidden(false);
		}

		private unhiddenCredito(montoOtorgadoInput: CtInputTextComponent,tasaInteresInput: CtInputTextComponent,tipoTasaInteresInput: CtInputTextComponent,plazoCreditoInput: CtInputTextComponent,cuotasCubiertasCredInput: CtInputTextComponent,cuotaMensualCredInput: CtInputTextComponent,saldoCancelarInput: CtInputTextComponent){
			montoOtorgadoInput.setHidden(false);
			tasaInteresInput.setHidden(false);
			tipoTasaInteresInput.setHidden(false);
			plazoCreditoInput.setHidden(false);
			cuotasCubiertasCredInput.setHidden(false);
			cuotaMensualCredInput.setHidden(false);
			saldoCancelarInput.setHidden(false);
		}		

		public setADN(numObjeto: number, titleObjeto: string){
			let contRequest = {
				"Type": 1,
				"UserCode": "SVA",
				"Source": "SVA",
				"Conditions":
				{
				  "Data": [{
					"Name": "NUM_OBJETO",
					"Alias": "NUM_OBJETO",
					"Value": numObjeto,
					"Display": "",
					"Type": 1,
					"FamilyId": ""
				  },
				  ]
				},
				"Data": [],
				"Files": []
			  }

			  if(numObjeto){
				if(titleObjeto =='Póliza de vida'){
					this.httpService.post(HttpService.ENDPOINT + '/api/process/OBJETOS_CLIENTE/SER_RET_POLIZA_DTL', contRequest).subscribe({
						next: (response: ApiResponseModel) => {
						  console.log(response['Data']);
						  this.loadDetalleSummary(response,1)
						},
						error: (error: any) => {
						  console.log(error);
						  
						}
					  });
				}else {
					this.httpService.post(HttpService.ENDPOINT + '/api/process/OBJETOS_CLIENTE/SER_RET_CRED_DTL', contRequest).subscribe({
						next: (response: ApiResponseModel) => {
						  console.log(response['Data']);
						  this.loadDetalleSummary(response,2)
						},
						error: (error: any) => {
						  console.log(error);
						}
					  });
				}
				
			  }
		}

		//Logica de cuenta IBAN
		private setCuentaIban(cuentaIban: string, card: CtCardComponent){
			if(cuentaIban == ''){
				this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'No hay una cuenta IBAN asociada al producto consultado. Si necesita una, por favor contáctenos por el chat o alguno de nuestros medios.',
				true, 'Aceptar', 'Cancelar');
			}else{
				card.setClipboardValue(cuentaIban);
			}
		}
	

		// Logica para los mensajes
		// Muestra el mensaje para la poliza de beneficios.
		private setMutuMessagesUnhidden(ctHeaderMutuButton: CtHeaderComponent, ctBtnMutu: CtButtonComponent){
			ctHeaderMutuButton.setHidden(false);
			ctBtnMutu.setHidden(false)
		}


		public setMessage (numObjeto: number, container: CtMessageContainerComponent) {
			let contRequest = {
			  "Type": 1,
			  "UserCode": "SVA",
			  "Source": "SVA",
			  "Conditions":
			  {
				"Data": [{
				  "Name": "NUM_OBJETO",
				  "Alias": "NUM_OBJETO",
				  "Value": numObjeto,
				  "Display": "",
				  "Type": 1,
				  "FamilyId": ""
				},
				]
			  },
			  "Data": [],
			  "Files": []
			}
		
			if (numObjeto) {
			  this.httpService.post(HttpService.ENDPOINT + '/api/process/OBJETOS_CLIENTE/SER_RET_MSJ_EST_OBJETO', contRequest).subscribe({
				next: (response: ApiResponseModel) => {
				  container.setValue(response['Data']);
				
				}
			  });
			}
		  }

	   private setStyleForEstadoObjeto(cuotasAdeudadas : string, estadoObjeto: string): void {
		const inputCuotasAdeudadas = document.getElementById('AV_VI11_txtCtInputText_2adeuda');
		const inputEstado = document.getElementById('AV_VI11_txtCtInputText_2a25c01p');
		const inputEstadoObjeto= inputEstado.querySelector('input');
		if(parseInt(cuotasAdeudadas)>0){
			const inputCuotasElement= inputCuotasAdeudadas.querySelector('input');
			inputCuotasElement.style.setProperty('color', 'red', 'important');
		}

		if(estadoObjeto !== 'Activo' && estadoObjeto !== 'Desembolsado' && estadoObjeto !== 'Al Día'){
			inputEstadoObjeto.style.setProperty('color','red','important');
		}
		}

		public navigateToPolizaSSVMN(): void {
			window.open('https://sociedaddesegurosdevida.cr/la-poliza', '_blank');
		}
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}